import React, { FC, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import TableTab from "../components/tabs/table-tab";
import { BUILDINGS } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { Category } from "../models/Category";
import columns from '../models/ColumnDefinitions/BuildingColumns';
import { Filter } from "../models/Filter";
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from '../models/search/BuildingSearch';
import SiteSearch from "../models/search/SiteSearch";
import { DeleteEntityResult } from "../models/services/DeleteEntityResult";
import { deleteBuilding, getBuildings } from "../services/buildingService";
import { getSiteNamesWithPagination } from "../services/siteService";
import TableContextStateMonitor from "../contexts/table/TableContextStateMonitor";

interface Props {
    setBusy: (isBusy: boolean) => void,
    categories: Category[],
    setCategories: (category: Category[]) => void
    onFilterChange: (filter: Filter[]) => void
}

const BuildingsTab: FC<Props> = ({ setBusy, categories, setCategories, onFilterChange }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.buildings);
    const [lookup, setLookup] = useState<Lookup[]>([]);
    const itemPath = '/access-control/hardware/building/';

    useEffect(() => {
        (async () => {
            setLookup([{
                name: LookupTypes.site,
                values: [],
                dataMethod: getSiteNamesWithPagination,
                searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
            }]);
        })();
    }, [])

    const onDelete = (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deleteBuilding(id)
                .then(
                    deleteResult => {
                        resolve(deleteResult);
                        setCategories([{ ...categories[0], count: (categories[0]?.count ?? 1) - 1 }]);
                        setBusy(false);
                    },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    })
        });
    }

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = BUILDINGS;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail) => void) => {
        setDetails(userLoginId, currentMenuDetail);
    }
    // <-- end context

    return (<TableContextProvider
        dataMethod={getBuildings}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        useFilter
        useSort
        usePagination
        useSearch
        useTable
        deleteMethod={onDelete}
        lookup={lookup}
        customDelete={{ fieldName: "isDefault", comparisonValue: false }} >
        <TableContextStateMonitor onFilterChange={onFilterChange} />
        <TableTab
            title={title}
            selectRows={false}
            rowPath={itemPath}
            cyName="buildings"/>
    </TableContextProvider >
    );
};

export default BuildingsTab;
